import { render, staticRenderFns } from "./ClasesDetalle.vue?vue&type=template&id=a9a0c5e6&"
import script from "./ClasesDetalle.vue?vue&type=script&lang=js&"
export * from "./ClasesDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports